import React from 'react';
import { 
  User, 
  GraduationCap, 
  Briefcase, 
  Award, 
  CheckCircle, 
  ShieldCheck, 
  TrendingUp 
} from 'lucide-react';
import newton from "../assets/newton.png";
const Newton = () => {
  const skills = [
    "Audit and Assurance", "Accounting", "Taxation", 
    "Strategic Planning", "Risk Management", "Internal Audit & Investigations", 
    "Budgeting & Control", "Credit Management", "Product Pricing", "Cost Control"
  ];

  return (
    <div className="profile-card">
      <style>{`
        .profile-card {
          font-family: 'Inter', system-ui, sans-serif;
          background: rgba(255, 255, 255, 0.8);
          backdrop-filter: blur(12px);
          border-radius: 24px;
          border: 1px solid rgba(255, 255, 255, 0.3);
          box-shadow: 0 20px 40px rgba(0,0,0,0.05);
          padding: 40px;
          max-width: 900px;
          margin: 20px auto;
          color: #1e293b;
        }
        .hero-section-2 {
          display: flex;
          gap: 32px;
          align-items: center;
          margin-bottom: 40px;
          border-bottom: 1px solid #f1f5f9;
          padding-bottom: 32px;
        }
        .avatar-container {
          position: relative;
          flex-shrink: 0;
        }
        .avatar-img {
          width: 140px;
          height: 140px;
          border-radius: 20px;
          object-fit: cover;
          box-shadow: 0 10px 20px rgba(16, 185, 129, 0.15);
          border: 4px solid white;
        }
        .badge-grid {
          display: flex;
          gap: 8px;
          margin-top: 12px;
        }
        .pill {
          font-size: 12px;
          font-weight: 600;
          padding: 4px 12px;
          background: #ecfdf5;
          color: #059669;
          border-radius: 100px;
          text-transform: uppercase;
        }
        .grid-layout {
          display: grid;
          grid-template-columns: 1fr 2fr;
          gap: 40px;
        }
        .section-title {
          font-size: 13px;
          font-weight: 700;
          color: #94a3b8;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          margin-bottom: 16px;
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .skill-tag {
          display: flex;
          align-items: center;
          gap: 10px;
          background: white;
          padding: 12px;
          border-radius: 12px;
          font-size: 14px;
          border: 1px solid #f1f5f9;
          transition: all 0.2s;
        }
        .skill-tag:hover {
          transform: translateY(-2px);
          border-color: #10b981;
          box-shadow: 0 4px 12px rgba(16, 185, 129, 0.1);
        }
        @media (max-width: 768px) {
          .hero-section-2, .grid-layout { flex-direction: column; grid-template-columns: 1fr; }
          .avatar-img { width: 100px; height: 100px; }
        }
      `}</style>

      <div className="hero-section-2">
        <div className="avatar-container">
          <img src={newton} alt="Newton Mathew" className="avatar-img" />
        </div>
        <div>
          <h1 style={{ fontSize: '32px', fontWeight: '800', margin: '0 0 4px 0', color: '#0f172a' }}>
            CPA Newton Mathew
          </h1>
          <p style={{ fontSize: '18px', color: '#10b981', fontWeight: '500', margin: '0' }}>
            ACPA-PP, B.Com — Partner
          </p>
          <div className="badge-grid">
            <span className="pill">Tax Consultant</span>
            <span className="pill">Auditor</span>
            <span className="pill">Risk Specialist</span>
          </div>
        </div>
      </div>

      <div className="grid-layout">
        <aside className="space-y-8">
          <div>
            <h3 className="section-title"><GraduationCap size={16} /> Qualifications</h3>
            <p style={{ fontSize: '15px', lineHeight: '1.6' }}>
              <strong>B.Com in Accounting</strong><br />
              Associate CPA in Public Practice (ACPA-PP)<br />
              <span style={{ color: '#64748b' }}>Member of NBAA & TRA Registered Tax Consultant</span>
            </p>
          </div>
          
          <div style={{ background: '#f0fdf4', padding: '20px', borderRadius: '16px' }}>
            <h3 className="section-title"><ShieldCheck size={16} /> Strategic Impact</h3>
            <p style={{ fontSize: '14px', color: '#065f46', fontStyle: 'italic' }}>
              "Instrumental in recovering billions from overdue debts and securing clean audit reports for long-term non-compliant entities."
            </p>
          </div>
        </aside>

        <main>
          <h3 className="section-title"><Briefcase size={16} /> Professional Background</h3>
          <div style={{ color: '#334155', fontSize: '15px', lineHeight: '1.7', marginBottom: '32px' }}>
            Extensive experience with <strong>BP Tanzania Ltd</strong>, <strong>Twiga Bancorp</strong>, and <strong>Maendeleo Bank PLC</strong>. 
            Newton has a proven track record in manufacturing, oil & gas, and banking, focusing on 
            revenue leakage control and the design of credit and market risk frameworks.
          </div>

          <h3 className="section-title"><TrendingUp size={16} /> Core Competencies</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
            {skills.map((skill, i) => (
              <div key={i} className="skill-tag">
                <CheckCircle size={14} style={{ color: '#10b981' }} />
                {skill}
              </div>
            ))}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Newton;